module.exports = __webpack_public_path__ + "static/media/idit.05c7c129.png";